import { Component, inject, output } from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import { InputSimple, Select, Button, SimpleDialog, SimpleDialogLayout } from 'excellence-ui';
import { DocumentsStore } from '../../stores/documents.store';
import { form, FormField } from '@angular/forms/signals';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-documents-filter-form',
  imports: [
    InputSimple,
    NgIcon,
    Select,
    FormField,
    TranslocoPipe,
    Button,
    SimpleDialog,
    SimpleDialogLayout,
  ],
  templateUrl: './documents-filter-form.html',
})
export class DocumentsFilterForm {
  private documentsStore = inject(DocumentsStore);

  changeFilter = output();

  protected filterForm = form(this.documentsStore.filter);

  protected onChangeFilter() {
    this.changeFilter.emit();
  }
}
